import React from "react";
function PageNotFound(){
    const height = {
        height: "calc(100vh - 12em)"
    }
    return <>
        <div style={height} className="flex flex-col justify-center items-center ">
            <p className="text-6xl font-semibold pb-10">404 Page Not Found</p>
            <p className="text-2xl font-semibold pb-10">you should not be here</p>
            <a className="text-3xl font-semibold  text-red-700 outline outline-red-700 outline-2 rounded-full p-5 hover:outline-red-700 hover:text-white hover:bg-red-700 duration-300" href="/">Back to Home</a>
        </div> 
    </>
}
export default PageNotFound;